<template>
  <v-app>
    <Header></Header>
    <View></View>
    <Footer :full="false"></Footer>
    <DialogMessage :fechar="fecharMessage" :model="modelMessage" :title="dialog.title" :message="dialog.message" :response="dialog.response"></DialogMessage>
    <DialogAddressRegister :fechar="fecharAddress" :model="modelAddress" :address="address" :register="register"></DialogAddressRegister>
  </v-app>
</template>

<script>
import Header from './Header.vue';
import View from './View.vue';
import Footer from './Footer.vue';
import DialogMessage from '@/components/DialogMessage.vue';
import DialogAddressRegister from '@/components/DialogAddressRegister.vue';
import { mapActions } from 'vuex';

export default {
  name: 'Simple',
  components: {
    Header,
    View,
    Footer,
    DialogMessage,
    DialogAddressRegister
  },
  data(){
    return {
      modelMessage: false,
      modelAddress: false,
      address: null,
      register: null,
      dialog: {
        title: "",
        message: "",
        response: null,
        fechar: null
      },
      liveInterval: null,
    }
  },
  methods: {
    ...mapActions('main', {
      live: 'live'
    }),
    ...mapActions('cart', {
      sendCart: 'sendCart'
    }),
    fecharMessage: function(){
      this.modelMessage = false;
      this.dialog.title = "";
      this.dialog.message = "";
      this.dialog.response = null;
      if(this.dialog.fechar != null){
        this.dialog.fechar();
      }
      this.dialog.fechar = null;
    },
    fecharAddress: function(){
      this.modelAddress = false;
    },
    timeSendCart(){
      if(this.cartInterval){
        clearInterval(this.cartInterval);
      }
      this.cartInterval = setInterval(() => {
        this.sendCartWs();
      }, 3000);
    },
    sendCartWs(){
      this.sendCart().then(function(response){
        if(response){
          clearInterval(this.cartInterval);
        }
      }.bind(this));
    }
  },
  mounted(){
    this.emitter.on('dialogMessage', function({ title = '', message = '', fechar = null, response = null}){
      this.dialog.title = title;
      this.dialog.message = message;
      this.dialog.response = response;
      this.dialog.fechar = fechar;
      this.modelMessage = true;
    }.bind(this));
    this.emitter.on('dialogAddress', function({ address = null, register = null }){
      this.register = register;
      this.address = address;
      this.modelAddress = true;
    }.bind(this));
    this.emitter.on('sendCart', function(){
      this.timeSendCart();
    }.bind(this));
    this.liveInterval = setInterval(() => {
      this.live();
    }, 20000);
  },
  created() {
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
  },
  unmounted(){
    this.emitter.off('sendCart');
    clearInterval(this.liveInterval);
  }
}
</script>